export default {"src":"/_next/static/media/author-photo-sparkles.dd776cf7.svg","height":92,"width":291,"blurWidth":0,"blurHeight":0};